<!-- Created by jack on 2022/2/28 - 15:12 -->
<style scoped lang="less">
.box{
  &__list{
    width: 100%;
    max-height: 500px;
    &__row{
      display: inline-block;
      position: relative;
      margin-top: 24px;
      width: 100%;
      &__rank{
        width: 22px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #2877FF;
      }
      &__top{
        padding: 8px 22px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        &__image{
          width: 56px;
          height: 54px;
          border: 1px solid #F6F6F6;
          box-sizing: border-box;
          border-radius: 8px;
          margin-right: 8px;
          object-fit: cover;
        }
        &__info{
          &__title{
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            color: #141B27;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
          &__sub-title{
            margin-top: 8px;
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 12px;
            color: #A1A4A9;

          }
        }
      }
      &__bottom{
        margin-top: 12px;
        background: #FBFAFA;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        &__item{
          padding: 12px 0;
          flex: 1;
          &__title{
            width: 100%;
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 12px;
            /* identical to box height, or 100% */
            text-align: center;
            color: #A1A4A9;
          }
          &__value{
            margin-top: 8px;
            width: 100%;
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 14px;
            text-align: center;
            color: #141B27;

          }
          &__focus{
            color: #FF5000;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="box" v-if="list.length">
    <van-list class="box__list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getListData" >
      <router-link :to="item.liveLink" class="box__list__row" v-for="(item,index) of list" :key="index">
        <div class="box__list__row__rank">{{ index + 1 }}</div>
        <!--     上部分-->
        <div class="box__list__row__top">
          <img :src="item.liveImage" class="box__list__row__top__image">
          <div class="box__list__row__top__info">
            <div class="box__list__row__top__info__title">{{ item.title }}</div>
            <div class="box__list__row__top__info__sub-title">{{ item.startTime }}</div>
          </div>
        </div>
        <!--     下部分   -->
        <div class="box__list__row__bottom">
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">直播价格</div>
            <div class="box__list__row__bottom__item__value">{{ item.price }}</div>
          </div>
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">销量</div>
            <div class="box__list__row__bottom__item__value">{{ item.salesVolume }}</div>
          </div>
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">销售额</div>
            <div class="box__list__row__bottom__item__value box__list__row__bottom__item__focus">{{ item.sales }}</div>
          </div>
        </div>
      </router-link>
    </van-list>
  </div>
  <NoneData v-else propsText="该主播在所选时间范围内没有卖货" :height="5" :imgSize="1.65"/>
</template>

<script>
import moment from "moment";

export default {
  props:{
    show:{ type:Boolean, default:false, },
    time:{ type:Array, default: () => ([]) }, // 时间参数
    goodsId:{ type:[String,Number], default: null }
  },
  watch:{
    show:{
      immediate:true,
      handler(value){
        if(value && this.$props.goodsId){
        this.listParams.pageNum = 1
        this.listApiData = {}
        this.getListData()
      }}
    }
  },
  data:(_this = this) => ({
    loading:true,
    listParams:{ // 列表参数
      pageNum:1,
      pageSize:25,
      order:'desc',
      sort:'startTime'
    },
    listApiData:{},
  }),
  computed:{
    params:(_this = this) => ({
      time:`$between:[${_this.time[0]},${_this.time[1]}]`,
      ..._this.listParams
    }),
    list:(_this = this) => (_this.listApiData?.data?.map((ele,index) => ({
      liveImage: ele?.liveStreamLog?.poster || _this.$defaultSrc, // 图片
      title: ele?.liveStreamLog?.title || '-', // 标题
      startTime: ele?.liveStreamLog?.startTime ? moment.unix(ele?.liveStreamLog?.startTime).format('MM-DD hh:ss开播 ') : '-', // 开播时间
      price: ele?.price ? '¥' +  _this.$retainWan(ele?.price) : '-', // 直播价格
      salesVolume: ele?.salesVolume ? _this.$retainWan(ele?.salesVolume) : '-', // 销售额
      sales: ele?.sales ? '¥' +  _this.$retainWan(ele?.sales) : '-', // 销售额
      liveLink: ele?.liveStreamLog?.id ? `/live/${_this.$route.params.id}/${ele?.liveStreamLog?.id}` : '', // 直播链接
    })) || []),
    finished:(_this = this) => (_this.listApiData?.paging?.count || 0) === (_this.list.length || 0)
  },
  methods:{
    async getListData(){
      this.loading = true
      this.$showLoading()
      this.listApiData = await this.$api.get(`/v2/anchor/${this.$route.params.id}/liveStreamCommodity/${this.$props.goodsId}/liveStream`, {params: this.params})
          .then(_ =>{
            this.listParams.pageNum ++
            return this.listParams.pageNum - 1 > 1 ? { paging: _?.data?.paging, data: [...this.listApiData.data, ..._?.data?.data] } :_?.data || {}
          })
          .catch(_ => ( this.listApiData ))
      this.loading = false
      this.$hideLoading()
    }
  }
}
</script>
